import { render, staticRenderFns } from "./Ref.vue?vue&type=template&id=7a153f67&scoped=true&"
import script from "./Ref.vue?vue&type=script&lang=js&"
export * from "./Ref.vue?vue&type=script&lang=js&"
import style0 from "./Ref.vue?vue&type=style&index=0&id=7a153f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a153f67",
  null
  
)

export default component.exports